import { timeSlots } from '@/mocks/homeData';

const quickLinks = [
  { id: 'schedule', label: '蹲瓜时间表' },
  { id: 'flash', label: '最新快讯' },
  { id: 'hot', label: '热门大瓜榜' },
  { id: 'columns', label: '栏目专区' },
  { id: 'guide', label: '吃瓜指南' },
  { id: 'faq', label: '常见问题' },
];

const scrollTo = (id: string) => (e: React.MouseEvent) => {
  e.preventDefault();
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

export default function Footer() {
  return (
    <footer className="border-t border-background-300 bg-background-200 text-foreground-800">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <a href="#top" onClick={scrollTo('top')} className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg" />
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">
                大瓜<span className="text-primary-600">预警</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              把娱乐话题的节奏整理成可预期的时间表——周一见、周五晚、周末大瓜、月末盘点、季度压轴。
              照表蹲守，重要节点不迷路。
            </p>
            <div className="mt-5 flex gap-2.5">
              {['ri-weibo-line', 'ri-douban-line', 'ri-bilibili-line', 'ri-wechat-line'].map((icon) => (
                <a
                  key={icon}
                  href="#top"
                  aria-label="社交媒体入口"
                  onClick={scrollTo('top')}
                  className="flex h-10 w-10 items-center justify-center rounded-lg bg-background-50 text-lg text-foreground-700 transition hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={icon} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-bold text-foreground-950">站内导航</h4>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5 text-sm">
              {quickLinks.map((l) => (
                <li key={l.id}>
                  <a href={`#${l.id}`} onClick={scrollTo(l.id)} className="text-foreground-600 transition hover:text-primary-600">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-foreground-950">蹲瓜节点</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {timeSlots.map((s) => (
                <li key={s.id}>
                  <a href="#schedule" onClick={scrollTo('schedule')} className="flex items-center gap-2 text-foreground-600 transition hover:text-primary-600">
                    <i className="ri-time-line text-primary-400" />
                    {s.tag}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-300/70 bg-background-300/40">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-5 text-sm text-foreground-600 md:flex-row md:px-6">
          <p>© 2026 大瓜预警 · 让每次蹲守都有章可循</p>
          <div className="flex items-center gap-5">
            <a href="mailto:hello@daguayujing.example" className="transition hover:text-primary-600">
              联系我们
            </a>
            <a href="#subscribe" onClick={scrollTo('subscribe')} className="transition hover:text-primary-600">
              订阅蹲位
            </a>
            <span className="text-foreground-500">陪你从周一到季度压轴</span>
          </div>
        </div>
      </div>
    </footer>
  );
}